import * as React from 'react';
import useSiteUrl from 'core/hooks/useSiteUrl';
import { Helmet } from 'react-helmet';
import { canonicalizePathName } from '../../lib/util';

type MetaPaginationProps = {
    tag: string;
    category: string;
    page: number;
    hasMore?: boolean;
};

function createUrl(
    siteUrl: string,
    category: string,
    tag: string,
    page: number,
): string {
    let pathname = `/blog/${category}/${tag}`;

    if (page > 1) {
        pathname += `/${page}`;
    }

    return [siteUrl, canonicalizePathName(pathname)].join('');
}

export default function MetaPagination({
    category,
    tag,
    page,
    hasMore,
}: MetaPaginationProps) {
    const siteUrl = useSiteUrl();
    if (page > 1 || hasMore) {
        return (
            <Helmet>
                {hasMore && (
                    <link
                        rel="next"
                        href={createUrl(siteUrl, category, tag, page + 1)}
                    />
                )}
                {page > 1 && (
                    <link
                        rel="prev"
                        href={createUrl(siteUrl, category, tag, page - 1)}
                    />
                )}
            </Helmet>
        );
    }

    return null;
}
